module.exports = __webpack_public_path__ + "img/vippack_cod.5ffa4ef0.png";